import { Theme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import commonStyle from "../../CommonStyle";

const triggerDefinitionSimpleDialogStyle = (theme: Theme) =>
    createStyles({
        ...commonStyle(theme),

        root: {
            paddingTop: theme.spacing(5),
            paddingRight: theme.spacing(5),
            paddingBottom: theme.spacing(5),
            paddingLeft: theme.spacing(5),
        },

        tooltipBackground: {
            backgroundColor: theme.palette.common.white,
            color: "rgba(0, 0, 0, 0.87)",
            zIndex: 100,
        },
        selectItem: {
            height: theme.spacing(1.5),
            boxSizing: "content-box",
            paddingTop: "11px",
            paddingBottom: "11px",
        },
    });

export default triggerDefinitionSimpleDialogStyle;
